export default __webpack_public_path__ + "static/media/logo_and_back.0480689c.svg";